/**
 * Buddy TOP — Lenis smooth scroll (IMAYO 準拠)
 * lerp: 0.075 / Windows: 0.15 / reduced-motion: 無効
 */
(function () {
  'use strict';

  if (typeof Lenis === 'undefined') return;
  if (window.Shopify && Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var root = document.documentElement;
  var isWin =
    /Win/i.test(navigator.platform || '') ||
    /Windows/i.test(navigator.userAgent || '');
  var lerp = isWin ? 0.15 : 0.075;

  var lenis = new Lenis({
    lerp: lerp,
    smoothWheel: true,
    syncTouch: false,
    autoRaf: true,
    anchors: true,
  });

  window.cTopLenis = lenis;

  lenis.on('scroll', function (e) {
    var v = e && typeof e.velocity === 'number' ? e.velocity : 0;
    if (Math.abs(v) > 3) {
      root.classList.add('is-scrolling');
    } else {
      root.classList.remove('is-scrolling');
    }
  });

  // テーマ内の固定/ドロワー等で一時停止できるように公開
  window.cTopLenisStop = function () {
    if (lenis) lenis.stop();
  };
  window.cTopLenisStart = function () {
    if (lenis) lenis.start();
  };
})();
